import { atom } from "jotai";

/**
 * Whether the jkurwa-web gate browser extension answered the check
 * `useExtensionGate` (`libs/data-web`) runs once at app start — `null` while
 * that check is still in flight (a few hundred ms at most). Written there
 * alone; every screen reads it with `useAtomValue`. See ai/docs/kep-signing.md.
 *
 * This mirrors, rather than drives, the transport decision itself:
 * `gatewayRequest` (`libs/kep`) consults its own synchronous
 * `isExtensionGateAvailable()` on every call, fed by the same detection —
 * not this atom, so that a low-level transport module never has to depend on
 * jotai.
 */
export const isExtensionGateConnectedAtom = atom<boolean | null>(null);
